// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".material__statistic_item[data-v-5c5f77d4]{display:flex;align-items:center;gap:calc(var(--scale)*2)}.material__statistic_item img[data-v-5c5f77d4]{width:calc(var(--scale)*24)}.material__statistic_item span[data-v-5c5f77d4]{font-weight:500;font-size:calc(var(--scale)*14);line-height:130%;color:#a7abac}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
